import { hanThanhToanSearchColumns, QUERY_KEYS } from '@/constants';
import { FormField, SearchField } from '@/components/custom/erp';
import { FormFieldActions, FormFieldState } from '../../hooks';
import { HanThanhToan } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface PaymentInfoTabProps {
  formMode: FormMode;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export const PaymentInfoTab: React.FC<PaymentInfoTabProps> = ({ formMode, formState: { state, actions } }) => {
  return (
    <div className='space-y-2 p-3'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Theo dõi thanh toán</Label>
          <div className='w-[250px]'>
            <FormField type='checkbox' name='hd_yn' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Số chứng từ</Label>
          <div className='w-[250px]'>
            <FormField type='text' name='so_ct0' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Ngày chứng từ</Label>
          <div className='w-[250px]'>
            <FormField type='date' name='ngay_ct0' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã thanh toán</Label>
          <div className='w-[250px]'>
            <SearchField<HanThanhToan>
              name='ma_tt'
              dialogTitle='Danh mục thanh toán'
              columnDisplay='ma_tt'
              displayRelatedField='ten_tt'
              searchColumns={hanThanhToanSearchColumns}
              searchEndpoint={`/${QUERY_KEYS.HAN_THANH_TOAN}/`}
              disabled={formMode === 'view'}
              onValueChange={actions.setThanhToan}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
